// MediaGalleryListItem
import React from 'react';
import PropTypes from 'prop-types';
import MediaGalleryImage from './MediaGalleryImage';
import MediaGalleryVideo from './MediaGalleryVideo';

const MediaGalleryListItem = props => (
  (props.item.type === 'Video')
    ? (
      <div className="col d-flex gallery-item gallery-item-video px-0" data-src={props.item.imageUrl}>
        <MediaGalleryVideo key={`video-${props.item.id}`} video={props.item} handleMediaClick={props.handleMediaClick} />
      </div>
    ) : (
      <div className="col d-flex gallery-item gallery-item-image px-0" data-src={props.item.imageUrl}>
        <MediaGalleryImage key={`image-${props.item.id}`} image={props.item} handleMediaClick={props.handleMediaClick} />
      </div>
    )
);

MediaGalleryListItem.propTypes = {
  handleMediaClick: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    type: PropTypes.string.isRequired,
    columnSize: PropTypes.string.isRequired,
    videoUrl: PropTypes.string,
  }),
};

export default MediaGalleryListItem;
